const FORMSVIEW = {
  nameAcivity: "Name/Activity",
  type: "Type",
  group: "Group",
  state: "State",
  totalQuestion: "All Questions",
  actions: "Actions",

  versions: "Versions",
  finish: "Finished",
  formType: "Form type",
  subForms: "SubForms",
  multiForms: "MultiForms",
  createdDate: "Creation date",
  updatedDate: "Update date",
  currentState: "Actual state",
  uniqueId: "unique form id",

  copyForm: "Copy form...",
  lockForm: "Lock form",

  tittleEdit: "Edit form",
  messageEdit: `This form has <strong>{version}</strong> version(s).`,
  messageEdit2: `Please select a version from the list, to proceed to its edition.`,
  version: "Version:",
  accept: "Accept",
  cancel: "Cancel",

  copyToForm: "Copy form",
  EnterNameToForm: "Enter a name for the new form:",
  copy: "copy",
  selectGorup: "Select the group:",

  tittleLockForm: `Close form: {activity}`,
  msgLockForm: "This action cannot be undone, are you sure?",

  tittleDeleteForm: "Delete form: {activity}",
  msgDeleteForm: "This option cannot be undone, are you sure you want to delete the form?",

  notifyClosedForm: {
    tittle: "Lock Forms",
    textSuccess: "The form has been locked successfully",
    textError: `An error occurred, locking the form({message})`
  },

  notifyCopyForm: {
    tittleGroup: "Group List",
    msgGroup: "An error occurred when consulting the list of Groups {message}",
    tittleCopyForm: "Copy Forms",
    msgErrorCopy: "An error occurred when consulting the form information",
    msgSuccessCopy: "Form copy successful",
    msgErrorCopyForm: `An error occurred while copying the form({message})`
  },

  notifyDeleteForm: {
    title: "Delete Forms",
    success: "The form was successfully deleted",
    error: "An error occurred while deleting the form"
  },

  notifyEditForm: {
    tittlemulti: "[MultiForms] Action not allowed",
    msgMulti: "There are no versions associated with MultiForms. Select a different form type.",
    tittle: "Edit Forms",
    msg: "An error occurred when consulting the form information"
  },

  filters: {
    update: "Actualizar",
    all: "Todos",
    actives: "Activos",
    deletes: "Eliminados"
  },

  dropdownMenu: {
    update: "Update",
    all: "All",
    actives: "Active",
    deletes: "Eliminated"
  }
};

export default { FORMSVIEW };
